const initCartOptimization = () => {
    const cartTitleObserver = new MutationObserver(() => {
        try {
            // Sidecart optimization: item count + recommendations heading copy
            const cartTitle = document.querySelector('#rebuy-cart-title');

            if (cartTitle && !cartTitle.dataset.gbInitialized) {
                cartTitle.dataset.gbInitialized = "true";
                setupSidecartCopy();
                cartTitleObserver.disconnect();
            }
        } catch (error) {
            console.error('Error initializing Cart Optimization:', error);
        }
    });

    cartTitleObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

};


function setupSidecartCopy() {
    try {
        const COUNT_CLASS = 'rebuy-cart__title-count';
        const DISCOUNT_FILLED_CLASS = 'sidecart-input--filled';
        const TOOLTIP_ARROW_SIZE = 12;
        const TOOLTIP_ARROW_INSET = 8;
        const RECOMMENDATIONS_TITLE = 'Complete your routine';
        const SUBSCRIPTION_LABEL = 'Subscribe & Save';
        const SUBSCRIPTION_TOOLTIP_ICON =
            '<svg data-sidecart-tooltip-icon="true" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
            '<path d="M7.5 15C11.625 15 15 11.625 15 7.5C15 3.375 11.625 0 7.5 0C3.375 0 0 3.375 0 7.5C0 11.625 3.375 15 7.5 15Z" fill="#232323"/>' +
            '<path d="M7.50171 10.5L7.50171 6.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M7.50586 4.5L7.49911 4.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>';
        const CHECKOUT_LOCK_ICON =
            '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
            '<path d="M3.27079 5.25V4.0625C3.27079 2.09719 3.86454 0.5 6.83329 0.5C9.80204 0.5 10.3958 2.09719 10.3958 4.0625V5.25" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M10 13.1667H3.66667C1.13333 13.1667 0.5 12.5069 0.5 9.86806V8.54861C0.5 5.90972 1.13333 5.25 3.66667 5.25H10C12.5333 5.25 13.1667 5.90972 13.1667 8.54861V9.86806C13.1667 12.5069 12.5333 13.1667 10 13.1667Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>';
        const CHECKOUT_SECURE_LABEL = '<span class="rebuy-cart__checkout-button-label">Secure Checkout</span>';
        const SUBSCRIPTION_TOOLTIP_ITEMS = [
            'Up to 25% off subscriptions',
            'Skip, reschedule, or cancel any time',
            'Subscription dashboard for full visibility and control',
            'Savings increase to 20% after 3 months'
        ];

        // Read the count Rebuy prints in the subtotal label ("Subtotal (5 items)").
        // Summing the quantity widgets over-counted — Rebuy keeps more than one
        // flyout render in the DOM, so every line item was counted once per render.
        // SmartCart.cart is only a fallback: rebuy:cart.change fires before the app
        // updates it, so item_count is one mutation behind at that point.
        const getItemCount = () => {
            const subtotalLabel = document.querySelector('.rebuy-cart__flyout-subtotal-label');
            const labelCount = subtotalLabel?.textContent.match(/\d+/)?.[0];

            if (labelCount) return parseInt(labelCount, 10);

            const appCount = window.Rebuy?.SmartCart?.cart?.item_count;
            return typeof appCount === 'number' ? appCount : 0;
        };

        const applyItemCount = () => {
            const cartTitle = document.querySelector('#rebuy-cart-title');
            if (!cartTitle) return;

            let counter = cartTitle.parentElement.querySelector(`.${COUNT_CLASS}`);
            const count = getItemCount();

            if (!count) {
                counter?.remove();
                return;
            }

            if (!counter) {
                counter = document.createElement('span');
                counter.className = COUNT_CLASS;
                cartTitle.insertAdjacentElement('afterend', counter);
            }

            const label = `( ${count} )`;
            // Guard against re-triggering the observer below with an identical write
            if (counter.textContent !== label) counter.textContent = label;
        };

        // The heading cannot be renamed in the Rebuy admin, so it is swapped here.
        const applyRecommendationsTitle = () => {
            const heading = document.querySelector('.rebuy-widget.widget-type-cart .primary-title');
            if (!heading) return;

            if (heading.textContent !== RECOMMENDATIONS_TITLE) heading.textContent = RECOMMENDATIONS_TITLE;
        };

        const closeTooltips = (except) => {
            document.querySelectorAll('.sidecart-tooltip.is-open').forEach((tooltip) => {
                if (tooltip === except) return;
                tooltip.classList.remove('is-open');
                tooltip.querySelector('.sidecart-tooltip__trigger')?.setAttribute('aria-expanded', 'false');
            });
        };

        // The panel width comes from the CSS container query, so it is measured
        // rather than assumed here. It is positioned inside the icon, which sits
        // mid-row — anchoring it to the icon pushes it past the flyout edge, and the
        // flyout clips its overflow. So the panel is centred against the flyout and
        // the arrow is moved back over the icon.
        const positionTooltipPanel = (tooltip) => {
            const panel = tooltip.querySelector('.sidecart-tooltip__panel');
            const flyout = tooltip.closest('.rebuy-cart__flyout');
            if (!panel || !flyout) return;

            const flyoutRect = flyout.getBoundingClientRect();
            const tooltipRect = tooltip.getBoundingClientRect();
            const panelWidth = panel.offsetWidth;
            if (!panelWidth) return;

            const panelLeft = flyoutRect.left + (flyoutRect.width - panelWidth) / 2;

            // Narrow panels may not reach under the icon, so the arrow is clamped to
            // stay inside the rounded corners instead of pointing off the panel.
            const maxArrowLeft = panelWidth - TOOLTIP_ARROW_SIZE - TOOLTIP_ARROW_INSET;
            const rawArrowLeft = tooltipRect.left + tooltipRect.width / 2 - panelLeft - TOOLTIP_ARROW_SIZE / 2;
            const arrowLeft = Math.min(Math.max(rawArrowLeft, TOOLTIP_ARROW_INSET), maxArrowLeft);

            panel.style.left = `${panelLeft - tooltipRect.left}px`;
            panel.style.right = 'auto';
            panel.style.setProperty('--sidecart-tooltip-arrow-left', `${arrowLeft}px`);
        };

        const buildTooltip = () => {
            const tooltip = document.createElement('span');
            tooltip.className = 'sidecart-tooltip';

            const trigger = document.createElement('span');
            trigger.className = 'sidecart-tooltip__trigger';
            trigger.setAttribute('role', 'button');
            trigger.setAttribute('tabindex', '0');
            trigger.setAttribute('aria-expanded', 'false');
            trigger.setAttribute('aria-label', 'Subscription benefits');
            trigger.innerHTML = SUBSCRIPTION_TOOLTIP_ICON;

            // Spans instead of a list: Rebuy's upsell is a real <button>, which only
            // takes phrasing content — the bullets are drawn in CSS.
            const panel = document.createElement('span');
            panel.className = 'sidecart-tooltip__panel';
            panel.setAttribute('role', 'tooltip');

            SUBSCRIPTION_TOOLTIP_ITEMS.forEach((text) => {
                const item = document.createElement('span');
                item.className = 'sidecart-tooltip__item';
                item.textContent = text;
                panel.appendChild(item);
            });

            // The trigger sits inside the subscription toggle, so its own events must
            // not bubble up and flip the subscription on/off.
            const toggle = (event) => {
                event.preventDefault();
                event.stopPropagation();
                const isOpen = tooltip.classList.toggle('is-open');
                trigger.setAttribute('aria-expanded', String(isOpen));
                if (isOpen) {
                    closeTooltips(tooltip);
                    positionTooltipPanel(tooltip);
                }
            };

            trigger.addEventListener('click', toggle);
            trigger.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') toggle(event);
            });

            // The panel also opens on hover/focus from CSS, so it is measured there too
            tooltip.addEventListener('mouseenter', () => positionTooltipPanel(tooltip));
            tooltip.addEventListener('focusin', () => positionTooltipPanel(tooltip));

            tooltip.append(trigger, panel);
            return tooltip;
        };

        // Rebuy's tooltip trigger is swapped in place so whatever listener the app
        // bound to the surrounding element survives the icon change.
        const applyTooltipIcon = (button, labelTarget) => {
            if (button.querySelector('.sidecart-tooltip')) return;

            const tooltip = buildTooltip();
            const currentIcon = button.querySelector('svg, i');

            if (currentIcon) {
                currentIcon.replaceWith(tooltip);
            } else {
                labelTarget.appendChild(tooltip);
            }
        };

        document.addEventListener('click', (event) => {
            if (!event.target.closest('.sidecart-tooltip')) closeTooltips();
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') closeTooltips();
        });

        window.addEventListener('resize', () => {
            document.querySelectorAll('.sidecart-tooltip.is-open').forEach(positionTooltipPanel);
        });

        // Rebuy prints its own subscription upsell copy ("Subscribe and save 15%",
        // "Save 15% with subscription", ...) and the discount differs per product,
        // so the percentage is reused from the original label instead of hardcoded.
        const applySubscriptionLabel = () => {
            const buttons = document.querySelectorAll(
                '.rebuy-cart__flyout-item-subscription .rebuy-button'
            );

            buttons.forEach((button) => {
                if (!button.dataset.sidecartOriginalLabel) {
                    button.dataset.sidecartOriginalLabel = button.textContent.trim();
                }

                const percent = button.dataset.sidecartOriginalLabel.match(/(\d+(?:[.,]\d+)?)\s*%/)?.[1];
                const label = percent ? `${SUBSCRIPTION_LABEL} ${percent}%` : SUBSCRIPTION_LABEL;
                // The tooltip is injected as a <span> ahead of the label, so plain
                // querySelector('span') picks it up on every pass after the first and
                // the label gets written over the tooltip, wiping trigger and panel.
                let labelTarget = [...button.querySelectorAll('span')].find(
                    (span) => !span.closest('.sidecart-tooltip')
                );

                // Rebuy does not always wrap the label in an element; without one of
                // its own the label would have to be written onto the button, which
                // would take the tooltip down with it.
                if (!labelTarget) {
                    labelTarget = document.createElement('span');
                    button.appendChild(labelTarget);
                }

                // Guard against re-triggering the observers below with identical writes
                if (labelTarget.dataset.sidecartLabel !== label) {
                    labelTarget.textContent = label;
                    labelTarget.dataset.sidecartLabel = label;
                }

                applyTooltipIcon(button, labelTarget);
            });
        };

        // Rebuy paints the discount field label as an overlay on top of the input,
        // and it stays there once a code is typed. There is no reliable CSS state
        // for "input has a value" (:placeholder-shown depends on a placeholder
        // attribute Rebuy does not always set), so the state is mirrored onto the
        // wrapper and the label is hidden from CSS.
        const applyDiscountFieldState = () => {
            document.querySelectorAll('#rebuy-cart__discount-input').forEach((input) => {
                const wrapper = input.closest('.rebuy-input-wrapper') || input.parentElement;
                if (!wrapper) return;

                wrapper.classList.toggle(DISCOUNT_FILLED_CLASS, input.value.trim() !== '');
            });
        };

        document.addEventListener('input', (event) => {
            if (event.target.id === 'rebuy-cart__discount-input') applyDiscountFieldState();
        });

        // The secure-checkout test that used to own this button markup is gone from
        // main, so the sidecart design ships its own padlock + label here.
        const applyCheckoutButtonLabel = () => {
            document.querySelectorAll('.rebuy-cart__checkout-button').forEach((button) => {
                if (button.dataset.sidecartCheckoutApplied) return;

                button.dataset.sidecartCheckoutApplied = 'true';
                button.innerHTML = CHECKOUT_LOCK_ICON + CHECKOUT_SECURE_LABEL;
            });
        };

        const applySidecartCopy = () => {
            applyItemCount();
            applyRecommendationsTitle();
            applySubscriptionLabel();
            applyDiscountFieldState();
            applyCheckoutButtonLabel();
        };

        applySidecartCopy();

        // Rebuy re-renders the flyout on every cart mutation, so the copy has to
        // be re-applied on each one, same as the checkout button label swap.
        document.addEventListener('rebuy:cart.ready', applySidecartCopy);
        document.addEventListener('rebuy:cart.change', applySidecartCopy);
        document.addEventListener('rebuy:cart.add', applySidecartCopy);

        // The events above land before Rebuy repaints, so also react to the repaint
        const cartRoot = document.querySelector('.rebuy-cart') || document.body;
        new MutationObserver(() => applySidecartCopy()).observe(cartRoot, {
            childList: true,
            subtree: true,
            characterData: true
        });
    } catch (error) {
        console.error('Error setting up sidecart copy:', error);
    }
}

initCartOptimization();
